// src/components/dashboard/employee/QuickLinksWidget.js
import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DashboardCard from '../DashboardCard';

function QuickLinksWidget({ userId }) {
  return (
    <DashboardCard title="Quick Links" icon="bi-link-45deg">
      <div className="d-grid gap-2">
        <Button as={Link} to={`/admin/employee/view/${userId}`} variant="outline-primary" size="sm">
          <i className="bi bi-person me-2"></i>My Profile
        </Button>
        <Button as={Link} to="/trainings" variant="outline-primary" size="sm">
          <i className="bi bi-search me-2"></i>Browse Trainings
        </Button>
      </div>
    </DashboardCard>
  );
}

export default QuickLinksWidget;
